const ADULT_SUFFIX = / - Adult$/;

export const groupPriceOptions = (ticketTypes) => {
  const ids = new Set(ticketTypes.map((tt) => tt.id));
  const nested = (tt) => tt.price_parent_id != null && ids.has(tt.price_parent_id);

  return ticketTypes.filter((tt) => !nested(tt)).map((tt) => {
    const options = ticketTypes.filter((option) => nested(option) && option.price_parent_id === tt.id);
    return options.length > 0
      ? { heading: tt.name.replace(ADULT_SUFFIX, ''), rows: [tt, ...options] }
      : { heading: null, rows: [tt] };
  });
};

export const rowLabel = (heading, ticketType) => {
  const prefix = `${heading} - `;
  return ticketType.name.startsWith(prefix) ? ticketType.name.slice(prefix.length) : ticketType.name;
};

export const quantityOptionsWithinOrderLimit = (rows, ticketType) => {
  const options = ticketType.available_quantity_options || [];
  const limit = rows[0].maximum_tickets_during_checkout;
  if (rows.length < 2 || !limit) { return options; }

  const others = rows.filter((row) => row !== ticketType).reduce((sum, row) => sum + (row.quantity || 0), 0);
  return options.filter((quantity) => quantity <= limit - others || quantity === (ticketType.quantity || 0));
};

export const priceOptionGroupForItem = (checkoutGroupItem, checkoutGroupItems, visibleTickets) => {
  const ids = new Set(checkoutGroupItems.filter((cgi) => cgi.item_type === 'TicketType').map((cgi) => cgi.item_id));
  const group = groupPriceOptions(visibleTickets.filter((tt) => ids.has(tt.id)))
    .find(({ rows }) => rows.some((tt) => tt.id === checkoutGroupItem.item_id));
  return group && group.rows[0].id === checkoutGroupItem.item_id ? group : null;
};
